/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { AdapterInterface } from "../../interfaces/Adapter.interface";
// CONSTANTS
import { BLANK_ADAPTER } from "../../constants/adapter";

export interface AdapterState {
	adapter: AdapterInterface;
	openDrawerAdapter: boolean;
	openModalCreateNewAdapter: boolean;
	adapterRefreshTable: boolean;
	openModalDeleteAdapter: boolean;
	formCreateEdit: string;
	openDrawerAssignActions: boolean;
}

const initialState: AdapterState = {
	adapter: { ...BLANK_ADAPTER },
	openDrawerAdapter: false,
	openModalCreateNewAdapter: false,
	adapterRefreshTable: false,
	openModalDeleteAdapter: false,
	formCreateEdit: "CREATE",
	openDrawerAssignActions: false,
};

export const adapterSlice = createSlice({
	name: "adapter",
	initialState,
	reducers: {
		updateAdapter: (state, action: PayloadAction<AdapterInterface>) => {
			state.adapter = action.payload;
		},
		updateOpenDrawerAdapter: (state, action: PayloadAction<boolean>) => {
			state.openDrawerAdapter = action.payload;
		},
		updateOpenModalCreateNewAdapter: (state, action: PayloadAction<boolean>) => {
			state.openModalCreateNewAdapter = action.payload;
		},
		updateAdapterRefreshTable: (state, action: PayloadAction<boolean>) => {
			state.adapterRefreshTable = action.payload;
		},
		updateOpenModalDeleteAdapter: (state, action: PayloadAction<boolean>) => {
			state.openModalDeleteAdapter = action.payload;
		},
		updateFormCreateEdit: (state, action: PayloadAction<string>) => {
			state.formCreateEdit = action.payload;
		},
		updateOpenDrawerAssignActions: (state, action: PayloadAction<boolean>) => {
			state.openDrawerAssignActions = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	updateAdapter,
	updateOpenDrawerAdapter,
	updateOpenModalCreateNewAdapter,
	updateAdapterRefreshTable,
	updateOpenModalDeleteAdapter,
	updateFormCreateEdit,
	updateOpenDrawerAssignActions,
} = adapterSlice.actions;

export default adapterSlice.reducer;
